module.exports = __webpack_public_path__ + "static/img/manworking.ffeea29.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/manworking.svg
// module id = pbSF
// module chunks = 1